import { Map } from 'immutable'

export const api = {
  /**
   * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
   */
  fetchEnrichedCompanyData(options = {}) {
    return Map()
  },

   /**
   * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
   */
  fetchDecodedCondition(provider, conditions = [], ip = '127.0.0.1', orgId) {
    return Map()
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/api.js